import { useUser } from '~/modules/auth/hooks/useUser';

// todo this is temporary while we have permissions enabled only for this type of emails
// will have more checks in the future
export const useIsExternalUser = () => {
  const { email } = useUser();

  return email.includes('+adapermissions');
};
